import { createContext } from 'react';
import type { Goal } from '@atlassian/jira-shared-types';

export const GoalFilterContext = createContext<{
	goals: Record<string, Goal>;
}>({ goals: {} });
